import { createSelector } from "reselect";
import { AppState } from "..";
import { SurferState } from "../types/surferTypes";

export const selectSurfer = createSelector(
  (state: AppState) => state.surfer,
  (surferState: SurferState) => surferState
);
